<script setup lang="ts">
    import useClient from '@/services/keyvue-api/composables/useClient';
    import { useRouter } from 'vue-router';
    import MercureConnection from '@/services/keyvue-api/mercure/MercureConnection';

    const { client } = useClient();
    await client.logout();

    const companyMercureConnection = MercureConnection.getInstance('company');
    companyMercureConnection.abort();

    const router = useRouter();
    router.push({ name: 'login' });
</script>
